import React from "react";
import { useNavigate } from "react-router-dom";
import HDFCLogo from "../../assets/BankLogo/hdfc.png";
import IDFCLogo from "../../assets/BankLogo/idfc.png";
import ICICILogo from "../../assets/BankLogo/icici.png";
import BOBLogo from "../../assets/BankLogo/baroda.png";


const HomeLoanBankOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "home",
      title: "Home Loan",
    },
  ];

  const loanData = [
    {
      loanType: "Home Loan",
      bank: "ICICI Bank",
      loanAmount: "₹1 Cr to ₹30 Cr",
      interestRate: "Starting @ 7.70%",
      tenure: "Upto 30 Years",
      tag: "Real Time Offer",
      bankLogo: ICICILogo
    },
    {
      loanType: "Home Loan",
      bank: "Bank of Baroda",
      loanAmount: "₹1 Cr to ₹20 Cr",
      interestRate: "Starting @ 7.50%",
      tenure: "Upto 30 Years",
      tag: "Real Time Offer",
      bankLogo: BOBLogo
    },
    {
      loanType: "Home Loan",
      bank: "HDFC Bank",
      loanAmount: "₹1 Cr to ₹10 Cr",
      interestRate: "Starting @ 7.90%",
      tenure: "Upto 30 Years",
      tag: "Real Time Offer",
      bankLogo: HDFCLogo
    },
    {
      loanType: "Home Loan",
      bank: "IDFC Bank",
      loanAmount: "₹1 Cr to ₹10 Cr",
      interestRate: "Starting @ 8.85%",
      tenure: "Upto 30 Years",
      tag: "Real Time Offer",
      bankLogo: IDFCLogo
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="pricing-main-container">
      <h4 className="bank-offer-title">{loanData[0].loanType}</h4>
      <p className="bank-offer-description">
        “Salaried individuals with a{" "}
        <span className="highlight-rate">net salary above ₹50,000 P/m.</span>
        <br /> Self-employed individuals with an{" "}
        <span className="highlight-rate">
          annual turnover above ₹1 crore can apply here.</span>”
      </p>
      <div className="pricing-cards">
        {loanData.map((loan, index) => (
          <div key={index} className="pricing-card">
            <div className="bank-header">
              <img src={loan.bankLogo} alt={loan.bank} className="bank-logo" />
              <h3 className="bank-name">{loan.bank}</h3>
            </div>
            <p>
              <strong>Loan Amount:</strong> {loan.loanAmount}
            </p>
            <p>
              <strong>Interest Rate:</strong> {loan.interestRate}
            </p>
            <p>
              <strong>Tenure:</strong> {loan.tenure}
            </p>
            <p className="offer-tag">{loan.tag}</p>
            {plans.map((plan, index) => (
              <button
                className="apply-button"
                key={index}
                onClick={() => handleApplyClick(plan.loanType)}
              >
                Check Eligibility
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default HomeLoanBankOffer;
